<script setup lang="ts">
definePageMeta({
  layout: 'one-column',
})

useSetSEO()
</script>

<template>
  <div class="page-auction">
    <div class="auction-header">
      <NovaBoxAuctionTopBanner />
    </div>
    <div class="auction-contents">
      <NovaBoxAuctions />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-auction {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-top: 30px;
  padding-bottom: 100px;
  min-width: 320px;

  .auction-issue {
    cursor: pointer;

    .inner {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      padding: 24px 12px;
      border-radius: 12px;
      background-color: $color-secondary-yellow-light-20;
      border-width: 2px;
      border-spacing: 2px;
      border-style: dashed;
      border-color: $color-black-10p;
      overflow: hidden;

      .lottie {
        position: absolute;
        top: -120px;
        right: -140px;
        opacity: 0.4;
      }

      .guide {
        width: 100%;
        @include text-style($text-body-14-bold);
        color: $color-text-1;
        text-align: center;
      }

      .chev {
        color: $color-text-1;
      }
    }
  }
  @include mobile {
    gap: 16px;
    padding-top: 0;
    padding-bottom: 60px;
    .auction-issue {
      padding: 0 15px;
    }
    .auction-contents {
      padding: 20px 15px 0 15px;
    }
  }
}
</style>
